import { type Salaries } from './salary-statistics'
import GraphItemFilled from './graph-item-filled'
import GraphItemDashed from './graph-item-dashed'
import { formatToDKK } from '../../lib/salary-statistics/tools'
import Divider from './divider'

export default function Graph({ salaries }: { salaries: Salaries }) {
  return (
    <div className="graph-wrapper">
      <div className="bar-lowest">
        <div className="bars">
          <GraphItemFilled color="#869FB3" />
          <GraphItemDashed color="#869FB3" />
        </div>
      </div>

      <div className="divider divider-lowest">
        <Divider />
      </div>

      {salaries.fr10 && (
        <div className="number number-lowest">
          <p>10% tjener under</p>
          <p className="typo__bold typo__bordeaux-color">
            {formatToDKK(salaries.fr10)}
          </p>
        </div>
      )}

      <div className="bar-median">
        <div className="bars">
          <GraphItemFilled color="#3D6586" />
        </div>
      </div>

      <div className="divider divider-median">
        <Divider />
      </div>

      {salaries.fr25 && salaries.fr75 && (
        <div className="number number-median">
          <p>50% tjener</p>
          <p className="typo__bold typo__bordeaux-color">
            {formatToDKK(salaries.fr25)}-{formatToDKK(salaries.fr75)}
          </p>
        </div>
      )}

      <div className="bar-highest">
        <div className="bars">
          <GraphItemDashed color="#0D3F68" />
          <GraphItemFilled color="#0D3F68" />
        </div>
      </div>

      <div className="divider divider-highest">
        <Divider />
      </div>

      {salaries.fr90 && (
        <div className="number number-highest">
          <p>10% tjener over</p>
          <p className="typo__bold typo__bordeaux-color">
            {formatToDKK(salaries.fr90)}
          </p>
        </div>
      )}
    </div>
  )
}
